export default {
    set: (name,value,expirationDays = null) => {
        window.parent.postMessage(["setCookie", name,value,expirationDays], "*");
    },
    getAll: (name) => {
        window.parent.postMessage(["getAllCookies"], "*");
    }
}
